import type { FaireProductEntity } from "../../entity_types/product";

export const p_8y5b63szua: FaireProductEntity = {
  token: "p_8y5b63szua",
  type: "product",
  name: "Sardines Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/355ec622c47fba902a5be4a977423a7472bb10cb1e113348b69f9c909c8efea6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d1e5b536975ef86604a320e65d93dc5120cedce3729b2ee8576bf08cb0e603e4.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:19.837Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
